import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'textInput',
    'colorInput',
    'emptyStateIcon',
    'colorPreview',
  ];

  connect() {
    this.updatePreview();
  }

  updateColor(e) {
    this.textInputTarget.value = e.target.value;
    this.textInputTarget.dispatchEvent(new Event('change'));

    this.updatePreview();
  }

  updatePreview() {
    const color = this.textInputTarget.value;

    if (color && this.textInputTarget.checkValidity()) {
      this.colorInputTarget.value = color;
      this.colorPreviewTarget.style.background = color;
      this.colorPreviewTarget.style.display = 'block';
      this.emptyStateIconTarget.style.display = 'none';
    } else {
      this.colorInputTarget.value = '#000000';
      this.colorPreviewTarget.style.background = 'transparent';
      this.colorPreviewTarget.style.display = 'none';
      this.emptyStateIconTarget.style.display = 'block';
    }
  }
}
